import { useNavigate } from 'react-router-dom';
import { useLocale } from '../../../context/NbLocalizationContext';
import { NbButton } from '../../../shared/components/button/Button';
import { routes } from '../../../shared/data/routes';
import classes from './NotFoundPage.module.scss';

export const NotFoundPage = () => {
  const { translation } = useLocale();
  const navigate = useNavigate();

  return (
    <div className={classes.notFound}>
      <div className={classes.notFoundBg}>{translation.notFound.fourOhFour}</div>
      <div className={classes.notFoundContent}>
        <h3>{translation.notFound.title}</h3>
        <div className={classes.notFoundContentError}>
          {/*// TODO: change id once we have it */}
          {/*<p>{translation.notFound.errorId}</p>*/}
          {/*<p>123456789</p>*/}
        </div>
        <div className={classes.notFoundContentButtonWrapper}>
          <NbButton
            className={classes.notFoundContentButton}
            onClick={() => navigate(routes.home)}
          >
            {translation.notFound.toHomePage}
          </NbButton>
        </div>
      </div>
    </div>
  );
};
